import { Box, ContentTemplate, KeyValue, SectionHeader } from 'web-library';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { makeStyles } from 'tss-react/mui';
import { UseFormReturn } from 'react-hook-form';
import ControlledAutocomplete from '../../../../components/form-items/ControlledAutocomplete';
import { keyValueResponseTransform } from '../../../../utils/DropdownUtils';
import { KeyValueResponse } from '../../../../api';
import { ExamSchoolFormData, ExamSchoolFormDataSPERS } from '../../../../models';

const useStyles = makeStyles()((theme) =>
({
  input: {
    marginBottom: theme.spacing(6),
  },
  keyValue: {
    marginBottom: theme.spacing(2),
  },
}));

interface AdmissionLevelSectionProps {
  isOpsAdmin?: boolean;
  isAeis?: boolean;
  formHook: UseFormReturn<ExamSchoolFormData> | UseFormReturn<ExamSchoolFormDataSPERS>;
  options: KeyValueResponse[];
  selectedAdmissionLevel: string;
  hasEditAccess: boolean;
}

const AdmissionLevelSection = ({
  isOpsAdmin = false,
  isAeis = false,
  formHook,
  options,
  selectedAdmissionLevel,
  hasEditAccess,
}: AdmissionLevelSectionProps) => {
  const { t } = useTranslation();
  const { classes } = useStyles();

  const { control, formState: { errors } } = formHook;

  return (
    <ContentTemplate isContinuable={isAeis} isDividerBottom={!isAeis}>
      <SectionHeader title={t('exam->>NonNationalExam.ExamDetail')} />

      {isOpsAdmin ? (
        <ControlledAutocomplete
          className={classes.input}
          id="inputSelect-levelSeekingAdmission"
          name="selectedAdmissionLevel"
          control={control}
          label={t('exam->>NonNationalExam.YouAreNowSeekingAdmission')}
          placeholder={t('exam->>NonNationalExam.YouAreNowSeekingAdmissionPlaceholder')}
          options={options}
          getOptionLabel={(option) => (typeof option === 'string' ? option : option.description)}
          transform={keyValueResponseTransform}
          error={!!errors.selectedAdmissionLevel}
          helperText={errors.selectedAdmissionLevel?.message?.toString()}
          isRequired
          disableClearable
          readOnly
          disabled={!hasEditAccess}
        />
      ) : (
        <Box className={classes.keyValue}>
          <KeyValue
            keyText={t('exam->>NonNationalExam.LevelSeekingAdmission')}
            valueText={selectedAdmissionLevel}
            capitalize={false}
          // variant="h6"
          />
        </Box>
      )}
    </ContentTemplate>
  );
};

export default AdmissionLevelSection;
